module.exports = __webpack_public_path__ + "images/file_icons_v2/markdown-4969712240a2d135cf401fb5d14f0c10.svg";